module.exports = __webpack_public_path__ + "img/Dr. Roop.092df219.jpeg";